export const CHANNELS_GET_USER_CHANNEL_LIST_SUCCESS = "CHANNELS_USER_GET_CHANNELS_LIST_SUCCESS";
export const CHANNELS_GET_USER_CHANNEL_LIST_FAILED = "CHANNELS_USER_GET_CHANNELS_LIST_FAILED";
export const CHANNELS_GET_USER_CHANNEL_LIST_LOADING = "CHANNELS_USER_GET_CHANNELS_LIST_LOADING";

export const CHANNELS_GET_MESSAGES_LIST_SUCCESS = "CHANNELS_GET_MESSAGES_LIST_SUCCESS";
export const CHANNELS_GET_MESSAGES_LIST_FAILED = "CHANNELS_GET_MESSAGES_LIST_FAILED";
export const CHANNELS_GET_MESSAGES_LIST_LOADING = "CHANNELS_GET_MESSAGES_LIST_LOADING";

export const CHANNELS_GET_MESSAGES_LIST_INTERNAT_SUCCESS = "CHANNELS_GET_MESSAGES_LIST_INTERNAT_SUCCESS";
export const CHANNELS_GET_MESSAGES_LIST_INTERNAT_FAILED = "CHANNELS_GET_MESSAGES_LIST_INTERNAT_FAILED";